import { Menu } from "../../menubar/ui/index.js";
import { Breadcrumbs } from "./breadcrumbs.js";
import { CustomBreadcrumbs } from "./custom-breadcrumbs.js";
import "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/header/components/content.tsx
var Content = ({ showLanguages = true, showMyAccount = true, showNotifications = true, showBreadcrumbs = true, customOptionsUser = [], customBreadcrumbs = false, version }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: "flex flex-col items-center",
		children: [/* @__PURE__ */ jsx(Menu, {
			showLanguages,
			showNotifications,
			showMyAccount,
			customOptionsUser,
			version
		}), showBreadcrumbs ? customBreadcrumbs ? /* @__PURE__ */ jsx(CustomBreadcrumbs, {}) : /* @__PURE__ */ jsx(Breadcrumbs, {}) : null]
	});
};
//#endregion
export { Content };
